export default "__VITE_ASSET__Dgy5pqdR__"